<template>
	<div class="row">
		<div class="col-12 col-lg-4 mb-4">
			<user-info></user-info>
		</div>
		<div class="col-12 col-lg-4" v-if="!isMobile">

			<bets-table :simple="true"></bets-table>
		</div>
		<div class="col-12 col-lg-4" v-if="!isMobile">
			<transaction-table :simple="true"></transaction-table>
			<div class="row mt-4">
				<div class="col-12">
					<router-link :to="{name: 'UserPayout'}" class="btn btn-primary">{{t('user.page.link.payout')}}</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

	import Vuex from 'vuex';
	import UserInfo from './modules/info';
	import BetsTable from './modules/betsTable';
	import TransactionTable from './modules/transactionTable';

	export default {
		name: 'UserHome',
		data() {
			return {

			}
		},
		components: {
			UserInfo,
			BetsTable,
			TransactionTable
		},
		computed:{
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters({
				user: 'getUser',
				userLogedIn: 'getUserStatus'
			}),
		}

	}
</script>